import type { PanelShortcut } from "../components/PinnedPanel";
import { useShiftOptionShortcut } from "./useShiftOptionShortcut";

export function usePanelShortcut(
  shortcut: PanelShortcut,
  onToggle: () => void,
  enabled: boolean
) {
  useShiftOptionShortcut(shortcut.code, onToggle, { enabled });
}
